import * as React from 'react';
import { LogoCentered } from 'src/app/Partials';

import '../ChangeEmail.page.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ChangeEmailSucceeded.messages';
import { Link } from 'react-router-dom';


export default class ChangeEmailSucceededPageComponent extends React.Component {

  public render() {
    return (
      <div className="page-changeemail d-flex justify-content-center align-items-center h-100">
        <div className="inner pt-5 pb-5">
          <LogoCentered />
          <div className="col-12">
            <h4>
              <FormattedMessage {...MESSAGES.emailChangedHeading} />
            </h4>
            <p>
              <FormattedMessage {...MESSAGES.emailChangedText} />
            </p>
            <Link className="btn btn-secondary d-block" to="/">
              <FormattedMessage {...MESSAGES.emailChangedButton} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
